import { MDBDataTableV5 } from "mdbreact";
import MiniLoader from "./MIniLoader";
import { Button, TableContainer } from "../styles";
import { ICON_PLUS, ICON_RELOAD } from "./icons";

export default function CustomTable({
      tableTitle,
      loading,
      getData,
      openAddModal,
      addTitle,

      datatable,

      ...props
}) {
      return (

            <TableContainer>
                  <div className="light-bg br-md">
                        <div className="d-md-flex d-block align-items-center justify-content-between py-3 px-2">
                              <div className="d-flex">
                                    <h5 className="pry-bold-text">{tableTitle}</h5>
                                    <MiniLoader
                                          load={loading}
                                    />
                              </div>
                              <div className=" d-flex  justify-content-start gap-2">


                                    <div className="pry-text h4 d-flex align-items-center mt-2"
                                          onClick={() => getData()}
                                          title="Reload"
                                    >

                                          {ICON_RELOAD}
                                    </div>

                                    {
                                          addTitle &&
                                          <Button pry className="btn"
                                                onClick={(e) => openAddModal()}
                                          >
                                                <span className="me-2">
                                                      {ICON_PLUS}
                                                </span>
                                                {addTitle}
                                          </Button>
                                    }
                                    {/* <Button pry
                                          // onClick={() => window.frames['frame1'].print()}
                                          className="btn">
                                          <span className="me-2">
                                                {ICON_PLUS}
                                          </span>                      Print
                                    </Button> */}
                              </div>
                        </div>
                        <div className="">

                              <MDBDataTableV5

                                    pagingTop
                                    entries={10}
                                    pagesAmount={4}
                                    data={datatable}
                                    responsive
                                    theadColor="sec-bold pry-text"
                                    maxHeight="700px"
                                    className="light-bg pt-2"
                                    {...props}
                              />

                        </div>
                  </div>
            </TableContainer >




      );
}
